/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Monthly cost trend data point
 */
export interface CloudCostMgmtCostTrend { 
    /**
     * Month in YYYY-MM format
     */
    month: string;
    /**
     * Total cost for the month in USD
     */
    cost: number;
}

